import React from 'react';
import { Check } from 'lucide-react';

const FEATURES = [
  'CRM y pipeline de ventas',
  'Clientes y seguimiento',
  'Facturas y créditos',
  'Productos e inventario con alertas',
  'Catálogo y pedidos en línea',
  'Calendario y entregas',
  'Multi-usuario para tu equipo',
  'Soporte por email',
  'Backup en la nube',
];

export const PricingSection: React.FC = () => {
  return (
    <section id="precios" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            💰 Un solo plan, precio claro
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Paga mes a mes o ahorra con el año completo por adelantado. Incluye prueba gratuita de 30 días.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 flex flex-col">
              <h3 className="text-lg font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Mensual
              </h3>
              <div className="mb-2">
                <span className="text-4xl font-bold text-gray-900">$35</span>
                <span className="text-gray-600 text-lg"> USD / mes</span>
              </div>
              <p className="text-gray-600 text-sm mb-6 flex-1">
                Facturación cada mes. Cancela cuando quieras. Precio en dólares estadounidenses (USD);
                tu banco o pasarela puede convertir a COP, MXN o ARS según el tipo de cambio del día.
                IVA u otros impuestos locales se informan en el checkout si aplican.
              </p>
              <a
                href="/registro"
                className="block w-full text-center py-3 px-6 rounded-lg font-semibold bg-gray-100 text-gray-900 hover:bg-gray-200 transition-colors"
              >
                Comenzar prueba gratis
              </a>
            </div>

            <div className="bg-white rounded-2xl shadow-lg border-2 border-green-500 p-8 flex flex-col relative ring-2 ring-green-500/20">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                <span className="bg-green-500 text-white px-4 py-1 rounded-full text-xs font-semibold">
                  Mejor valor
                </span>
              </div>
              <h3 className="text-lg font-semibold text-gray-500 uppercase tracking-wide mb-2 mt-2">
                Anual (prepagado)
              </h3>
              <div className="mb-1">
                <span className="text-4xl font-bold text-gray-900">$28</span>
                <span className="text-gray-600 text-lg"> USD / mes</span>
              </div>
              <p className="text-green-700 font-medium text-sm mb-1">
                $336 USD pagados una vez al año
              </p>
              <p className="text-gray-600 text-sm mb-6 flex-1">
                Equivale a $28/mes. Ahorras frente a 12 × $35.
              </p>
              <a
                href="/registro"
                className="block w-full text-center py-3 px-6 rounded-lg font-semibold bg-green-600 text-white hover:bg-green-700 transition-colors"
              >
                Comenzar prueba gratis
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 md:p-10">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
              Todo incluido en Clientelo
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {FEATURES.map((feature, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
